<div class="container-fluid py-5">
  <!-- <div class="card-tools"> -->
  <div class="row justify-content-center">
    <div
      class="col-4 col-md-2"
      *ngFor="let card of resumenCardsTwo; index as i"
    >
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 0 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
              >
                <!-- {{ card.value }} -->
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 1 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 1, 'text-white': i !== 1 }"
              >
                <!-- {{ card.value }} -->
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 1 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-6">
    <div class="col-11 d-flex align-items-center justify-content-between">
      <a class="btn btn-dark btn-sm btn-initial" (click)="openPlaidLink()">Add</a>
      

      <div class="flex-grow-1 text-center pl-4">
        <ng-container *ngFor="let item of banks; let i = index">
          <a
            class="btn btn-dark btn-sm btn-step me-2"
            (click)="changeStep(i); getTransactions(item.accessToken)"
          >
            {{ item.institution }}
          </a>
        </ng-container>
      </div>
    </div>
  </div>
  <!-- </div> -->

  <!-- <div class="card-tools">
    <div class="row mb-6 justify-content-center">
      <div class="col-md-6 text-center">
        <a class="btn btn-dark btn-sm btn-initial" (click)="pru()"> pru </a>
      </div>
    </div>
  </div> -->

  <h2>{{ step_name }}</h2>
  <h3>Plaid Integration Accounts</h3>

  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Balance</th>
              <th>Holder category</th>
              <th>Mask</th>
              <th>Name</th>
              <th>Official name</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of accounts">
              <td>
                {{ item.balances.iso_currency_code }}
                {{ item.balances.available }}
              </td>
              <td>
                {{ item.holder_category }}
              </td>
              <td>{{ item.mask }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.official_name }}</td>
              <td>{{ item.type }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <h3>Transactions</h3>

  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <!-- <tr>
              <th>Holder category</th>
              <th>Name</th>
              <th>Official name</th>
              <th>Type</th>
            </tr> -->
          </thead>
          <tbody>
            <!-- <tr *ngFor="let item of accounts">
              <td>
                {{ item.holder_category }}
              </td>
              <td>{{ item.name }}</td>
              <td>{{ item.official_name }}</td>
              <td>{{ item.type }}</td>
            </tr> -->
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
